import React from 'react';
import './Carousel.css';

const carousel = (props) => {
    return (
        <div className="carousel">
            <div className="container-fluid crContent">
                <h1 className="font-weight-bold text-left main">
                    {props.main}
                </h1>
                <h1 className="text-left main2">{props.main2}</h1>
                <br />
                <br />
                <p className="text-left text-dark content">
                    {props.content}
                </p>
            </div>
        </div>
    )
}

export default carousel;